import { AbstractControl } from '@angular/forms';

export class EguardValidationService {

    static getValidatorErrorMessage(validatorName: string, validatorValue?: any) {

        const config: any =  {
            'required': 'Required',
            'invalidCreditCard': 'Is invalid credit card number',
            'invalidEmailAddress': 'Invalid email address',
            'invalidPassword': 'Invalid. Password must be at least 8 characters long, and must contain a uppercase letter, lowercase letter, special character and number.',
            'invalidPhone' : 'Invalid phone. EX. 1.401.555.2222',
            'invalidPhoneCountry' : 'Invalid phone. No Country Code. EX. 1.401.555.2222',
            'stringNoSpecialChars' : 'Only Letters and Numbers',
            'stringOnlyLetters' : 'Only Letters are allowed',
            'invalidZip' : 'Zip Invalid 02920',
            'MatchPassword': 'Passwords does not match',
            'minlength': `Minimum length ${validatorValue.requiredLength}`
        };

        return config[validatorName];
    }

    static emailValidator(control: any) {
        // RFC 2822 compliant regex
        if (control.value.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/)) {
            return null;
        } else {
            return { 'invalidEmailAddress': true };
        }
    }

    static passwordValidator(control: AbstractControl) {
        // {6,100}           - Assert password is between 6 and 100 characters
        // (?=.*[0-9])       - Assert a string has at least one number
        if (control.value.match(/^(?=.*[0-9])[a-zA-Z0-9!@#$%^&*]{6,100}$/)) {
            return null;
        } else {
            return { 'invalidPassword': true };
        }
    }

    static phoneNumberValidator(control: any){
        // this first if will check to see if it is in phone number for mat
        // 4013028097
        // 401.302.8097
        let raw_ph = control.value.replace(/\D/g, '');
        if (raw_ph.substring(1).match(/^[1-9]{1}[0-9]{3,14}$/)) {

            // this second one sees if it has an country code or not.
            // 14013028097
            // 1.401.302.8097
            // if (control.value.match(/^[0-9]{1,2}[.-]?[0-9]{3}[.-]?[0-9]{3}[.-]?[0-9]{4}$/)){
            //     return null;
            // }
            // else{
            //     return { 'invalidPhoneCountry': true };
            // }

        } else {
            return { 'invalidPhone': true };
        }
    }

    static stringNoSpecialChars(control: any){
        // this will make sure that a string only has Numbers and letters
        if (control.value.match(/^[0-9a-zA-Z ]+$/)){
            return null;
        } else {
          return {'stringNoSpecialChars' : true};
        }
    }

    static stringOnlyLetters(control: any){
      if (control.value.match(/^[a-zA-Z ]+$/)){
          return null;
      } else {
        return {'stringOnlyLetters' : true};
      }
    }

    static zipcode(control: any){
        if (control.value.match(/^[0-9]{5}/)){
            return null;
        } else {
          return {'invalidZip' : true};
        }
    }

    static MatchPassword(AC: AbstractControl) {
        if (AC.get('password')){

        
        let password = AC.get('password').value; // to get value in input tag
        let confirmPassword = AC.get('confirmPassword').value; // to get value in input tag
         if (password !== confirmPassword) {
            
             AC.get('confirmPassword').setErrors( {MatchPassword: true} );
         } else {
           
             return null;
         }
        }
     }

}



// WEBPACK FOOTER //
// ./src/app/core/components/validation/validation.service.ts